export default "__VITE_ASSET__37db0c5c__"